import { CooperativeForm } from './components/form';
import { Cooperatives } from './components/table';
import { CooperativeView } from './components/view';

import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_COOPERATIVE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

export const states = [
  {
    name: 'base-layout.cooperatives',
    url: '/cooperatives',
    component: Cooperatives,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COOPERATIVE, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.cooperatives.create',
    url: '/new',
    component: CooperativeForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COOPERATIVE, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.cooperatives.edit',
    url: '/:cooperativeId/edit',
    component: CooperativeForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COOPERATIVE, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.cooperatives.view',
    url: '/:cooperativeId/view',
    component: CooperativeView,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COOPERATIVE, PERMISSION_READ]],
    },
  },
];
